import {
  Container as ChakraContainer,
  ContainerProps,
  forwardRef,
} from '@chakra-ui/react';
/**
 * Containers are used to constrain a content's width to the current breakpoint, while keeping it fluid.
 */
export const Container = forwardRef((props: ContainerProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <ChakraContainer ref={ref} {...otherProps}>
      {children}
    </ChakraContainer>
  );
});
